module.exports = __webpack_public_path__ + "img/sixpackcarrier72.452406fe.jpg";